import React, { useEffect, useState } from 'react';
import {
  WifiOff,
  Wifi,
  CheckCircle
} from '@mui/icons-material';
import { green, red } from '@mui/material/colors';

const InternetStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <div
      className="offline-banner"
      style={{
        backgroundColor: isOnline ? green[500] : '#FF9800',
        color: '#fff',
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}
    >
      {isOnline ? (
        <>
          <Wifi />
          You are online. All changes are synced successfully.
        </>
      ) : (
        <>
          <WifiOff />
          You are working offline. Your changes will sync when you're back online.
        </>
      )}
    </div>
  );
};

export default InternetStatus;
